import { render, staticRenderFns } from "./SVGProjectsCopy.vue?vue&type=template&id=1b099e46&scoped=true&"
import script from "./SVGProjectsCopy.vue?vue&type=script&lang=js&"
export * from "./SVGProjectsCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b099e46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b099e46')) {
      api.createRecord('1b099e46', component.options)
    } else {
      api.reload('1b099e46', component.options)
    }
    module.hot.accept("./SVGProjectsCopy.vue?vue&type=template&id=1b099e46&scoped=true&", function () {
      api.rerender('1b099e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGProjectsCopy.vue"
export default component.exports